import { useQuery } from 'hooks'
import { useMemo } from 'react'


const useVotings = ({ skip }: { skip: boolean }) => {
  const options = useMemo(() => ({
    url: '/api/statistics',
    skip,
    modifyResult: ({ votings }) => {
      const { total: votingsTotal } = votings

      return {
        votingsTotal,
      }
    },
  }), [ skip ])

  const { data, isFetching, errors } = useQuery<{ votingsTotal: number }>(options)
  const { votingsTotal } = data || {}

  return {
    votingsTotal,
  }
}

export default useVotings